import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Close } from "@mui/icons-material";
import { Divider, IconButton, Modal as MuiModal, Stack, styled, useTheme } from "@mui/material";
import { useId } from "react";
import { ModalContainer } from "./ModalContainer";
import { ModalHeader } from "./ModalHeader";
const StyledMuiModal = styled(MuiModal)({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0
});
export const Modal = (props)=>{
    const labelId = useId();
    const theme = useTheme();
    const ariaLabelledBy = typeof props.header === 'string' ? labelId : undefined;
    return /*#__PURE__*/ _jsx(StyledMuiModal, {
        onClose: props.locked ? undefined : props.onClose,
        open: !!(props.locked || props.isOpen),
        role: "presentation",
        slotProps: {
            backdrop: {
                style: {
                    backgroundColor: props.overlayColor ? theme.palette[props.overlayColor]?.main : undefined
                }
            }
        },
        children: /*#__PURE__*/ _jsxs(ModalContainer, {
            "aria-describedby": props['aria-describedby'],
            "aria-label": props['aria-label'],
            "aria-labelledby": props['aria-labelledby'] ?? ariaLabelledBy,
            "data-component": "modalContainer",
            "data-testid": props['data-testid'],
            lgWidth: props.lgWidth,
            mdWidth: props.mdWidth,
            role: props.role || 'dialog',
            children: [
                !!props.header && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Stack, {
                            alignItems: "center",
                            direction: "row",
                            display: "flex",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsx(ModalHeader, {
                                    id: ariaLabelledBy,
                                    children: props.header
                                }),
                                props.hasCloseBtn && /*#__PURE__*/ _jsx(IconButton, {
                                    color: "primary",
                                    "data-testid": props['data-testid'] && `${props['data-testid']}-close`,
                                    onClick: props.onClose,
                                    sx: {
                                        mr: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(Close, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Divider, {})
                    ]
                }),
                props.children
            ]
        })
    });
};
Modal.displayName = 'Modal';

//# sourceMappingURL=Modal.js.map